import { bffApi } from "../../../services/bff/bffApi";
import { createHTMLElement, downloadFile } from "../../../utils/downloadFiles";

export async function executeFluxDownload(
  relativePath: string,
  payload: object,
  fileName: string,
  type: string
): Promise<void> {
  const result = await bffApi.post(relativePath, { ...payload, Formato: type }, {
    responseType: 'blob',
  });

  downloadFile(createHTMLElement(result.data), fileName, type);
}
